import { useKeyboardState } from 'react-native-keyboard-controller';

export const useIsKeyboardShown = () => useKeyboardState().isVisible;
